import { FlagIcon } from "app/components/Icons";
import CustomTooltip from "app/components/Tooltip";
import CommonPrioritySelection from "app/containers/Features/components/CommonPrioritySelection";
import React from "react";
import { PriorityFilterEnum } from "../../../Ticket/types";
import { priorityOptions } from "../../data";

interface CustomProps {
  value: string;
  setValue: (val: string) => void;
    onOpen: () => void;
  onClose: () => void;
}

const PrioritySelection: React.FC<CustomProps> = ({ value, setValue ,onClose,onOpen}) => {
  const selectedOptions = priorityOptions.find((p) => p.value === value);

  return (
    <>
      <CommonPrioritySelection
        trigger={
          <button className="flex items-center justify-between w-full p-[6px] rounded-md hover:bg-[#F4F5F7] rounded-[4px] data-[state=open]:border-[#79808A] data-[state=open]:outline-[#79808A] data-[state=open]:border-[1px] border-[#79808A]">
            <CustomTooltip
              text="Click to choose priority"
              className="flex items-center gap-1"
              position="left"
            >
              {selectedOptions ? (
                <div className="flex items-center gap-1 w-full">
                  <FlagIcon size={16} color={selectedOptions.color} />
                  <span className={`text-sm font-normal text-secondary `}>
                    {selectedOptions.label}
                  </span>
                </div>
              ) : (
                <span className="text-xs leading-[18px] font-normal text-secondary">
                  Choose priority
                </span>
              )}
            </CustomTooltip>
          </button>
        }
        align="center"
        setValue={(val) => {
          setValue(val);
        }}
        value={value as PriorityFilterEnum}
        isHeader="Priority"
        dropDownClassName=" min-w-[230px] "
        onOpen={onOpen}
        onClose={onClose}
      />
    </>
  );
};

export default PrioritySelection;
